import request from '@/utils/http'

/**
 * 统计
 * @param payload
 */
export function stat(payload) {
    return request({ url: '/Index/index', method: 'get', params: payload })
}